import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const getReservationListService = async (payload) => {
  const payloadData = {
    search: payload?.search || '',
    status: payload?.status || '',
    tripType: payload?.tripType || '',
    bookingType: payload?.bookingType || '',
    pageSize: payload?.pageSize || '',
    dateFrom: payload?.dateFrom || '',
    dateTo: payload?.dateTo || '',
    type: payload?.type || payload?.location,
    location: payload?.city || '',
    parentCompany: payload?.parentCompany || '',
    companyId: payload?.companyId || '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;

  let url = '';
  if (payload.id) {
    url = `${env}${API_ENDPOINT.reservation.reservationApi}/${payload?.id}`;
  } else if (payload?.type || payload?.carTypeId) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      '?search=' +
      payloadData?.search +
      '&bookingType=' +
      payloadData?.bookingType +
      '&page=' +
      page +
      '&status=' +
      payloadData?.status +
      '&tripType=' +
      payloadData?.tripType +
      '&pageSize=' +
      payloadData?.pageSize +
      '&dateTo=' +
      payloadData?.dateTo +
      '&dateFrom=' +
      payloadData?.dateFrom +
      '&type=' +
      payload?.type
    }`;
  } else if (payload?.report) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      '?page=' +
      page +
      '&reports=true' +
      '&isB2B=true' +
      '&status=' +
      payloadData?.status +
      '&tripType=' +
      payloadData?.tripType +
      '&pageSize=' +
      payloadData?.pageSize +
      '&dateTo=' +
      payloadData?.dateTo +
      '&dateFrom=' +
      payloadData?.dateFrom +
      '&type=' +
      payload?.location +
      '&location=' +
      payload?.city +
      '&parentCompanyId=' +
      payload?.parentCompany +
      '&companyId=' +
      payload?.companyId
    }`;
  } else if (payload?.export) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      '?page=' +
      page +
      '&export=true' +
      '&isB2B=true' +
      '&status=' +
      payloadData?.status +
      '&tripType=' +
      payloadData?.tripType +
      '&pageSize=' +
      payloadData?.pageSize +
      '&dateTo=' +
      payloadData?.dateTo +
      '&dateFrom=' +
      payloadData?.dateFrom +
      '&type=' +
      payload?.location +
      '&parentCompanyId=' +
      payload?.parentCompany +
      '&companyId=' +
      payload?.companyId +
      '&location=' +
      payload?.city
    }`;
  } else {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      '?search=' +
      payloadData?.search +
      '&bookingType=' +
      payloadData?.bookingType +
      '&page=' +
      page +
      '&status=' +
      payloadData?.status +
      '&tripType=' +
      payloadData?.tripType +
      '&pageSize=' +
      payloadData?.pageSize +
      '&dateTo=' +
      payloadData?.dateTo +
      '&dateFrom=' +
      payloadData?.dateFrom
    }`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getReservationDetailsService = async (payloadId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.reservationApi}/${payloadId?.id || payloadId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addReservation = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.reservation.bookingApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateReservation = async (payloadData, payloadId) => {
  let data = {};
  let id = '';

  if (payloadData?.formData?.type) {
    data = payloadData?.formData;
    id = payloadData?.id;
  } else {
    data = payloadData;
    id = payloadId;
  }

  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.reservation.bookingApi}/${id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCancelReasonService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.cancelReasonApi}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getBookingBufferTimeService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.bufferTimeApi}/?type=${payload?.type}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getAirportTerminalListService = async (payload) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.reservation.bufferTimeApi}/?type=${payload?.type}&sourceAddress=${payload?.sourceAddress}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// export const getNotificationRecipientsService = async (tripId) => {
//   const res = await requestInstance
//     .get(
//       `${env}${API_ENDPOINT.reservation.notificationRecipientsApi}/${tripId}/notification-recipients`,
//     )
//     .catch((err) => err.response);
//   return setCurrentUser(res);
// };

export const getNotificationRecipientsService = async (tripId, notificationType) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.reservation.notificationRecipientsApi}/${tripId}/notification-recipients?notificationType=${notificationType}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const sendNotificationsService = async (tripId, payload) => {
  const res = await requestInstance
    .post(
      `${env}${API_ENDPOINT.reservation.sendNotificationsApi}/${tripId}/send-notifications`,
      payload,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const markTripAsNoShowService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.reservation.markNoShow}/${payload.tripId}/no-show`, {
      remarks: payload.remarks,
    })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const editDutySlipService = async (tripId, payload) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.reservation.editDutySlipApi}/${tripId}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getAllCitiesService = async (allCities = true) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.allCitiesApi}?allCities=${allCities}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const cancelPaymentLinkService = async (tripId, reason) => {
  const res = await requestInstance
    .post(
      `${env}${API_ENDPOINT.reservation.cancelPaymentLinkApi}/${tripId}`,
      { reason }, // Add reason to the request body
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getRateCardsV2Service = async (payload) => {
  const { companyId, location, type, carTypeId, rateCardTypeId, isMultiDay } = payload || {};
  let url = `${env}${API_ENDPOINT.reservation.rateCardsV2Api}?companyId=${companyId}&location=${location}&type=${type}&carTypeId=${carTypeId}`;
  if (rateCardTypeId) {
    url += `&rateCardTypeId=${rateCardTypeId}`;
  }
  // Rental: the multi-day toggle decides which shelf is shown — the corporate's
  // single-day packages or its one multi-day card. The backend filters on it.
  if (typeof isMultiDay === 'boolean') {
    url += `&isMultiDay=${isMultiDay}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getRateEstimateService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.reservation.rateEstimateApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getTollChargesService = async (params) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.tollChargesApi}`, { params })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addTollChargeService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.reservation.tollChargesApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateTollChargeService = async (id, payload) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.reservation.tollChargesApi}/${id}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const deleteTollChargeService = async (id) => {
  const res = await requestInstance
    .delete(`${env}${API_ENDPOINT.reservation.tollChargesApi}/${id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
